import React, { useState } from 'react';
import { Card, Row, Col, Form, Spinner, Button } from 'react-bootstrap';
import Chart from 'react-google-charts';
import axios from 'axios';
import { getCurrentMonth, getCurrentYear, getFiscalYear } from '../Util';

export default function SiteAssociateAnnualReport() {

    const OPERATIONAL_BASE_URL = process.env.REACT_APP_OPERATIONAL_BASE_URL;
    const OPERATIONAL_SEARCH = process.env.REACT_APP_OPERATIONAL_SEARCH;

    const FISCAL_BASE_URL = process.env.REACT_APP_FISCAL_BASE_URL;
    const FISCAL_SEARCH = process.env.REACT_APP_FISCAL_SEARCH;

    const [operationalData, setOperationalData] = useState([]);
    const [fiscalData, setFiscalData] = useState([]);
    const visitData = {
        siteName: "",
        year: "",
        month: "",
        status: "APPROVED"
    }
    const [spinner, setSpinner] = useState(false);


    const handleSiteChange = (e) => {
        console.log(e.target.value);
        visitData.siteName = e.target.value;
        const operationalAPI = OPERATIONAL_BASE_URL + OPERATIONAL_SEARCH;
        setSpinner(true);
        if (operationalAPI) {
            axios.post(operationalAPI, visitData)
                .then((response) => {
                    setOperationalData(getAssociateOperationalData(response.data));
                    setSpinner(false);
                })
                .catch((error) => { console.error(error) })

        }
        const fiscalAPI = FISCAL_BASE_URL + FISCAL_SEARCH;
        if (fiscalAPI) {
            setSpinner(true);
            axios.post(fiscalAPI, visitData)
                .then((response) => {
                    setFiscalData(getAssociateFiscalData(response.data));
                    setSpinner(false);
                })
                .catch((error) => console.error(error));


        }
    };
    const getAssociateOperationalData = (operationalData) => {
        if (!operationalData) return;
        const siteFiscalData = {};
        const currentFiscalYear = getFiscalYear(getCurrentYear, getCurrentMonth);
        console.log(`current Fiscal Year :${currentFiscalYear}`);
        // TODO: add this condition to the filter with current  && e.fiscalYear === currentFiscalYear
        const operData = operationalData.filter(e => e.status === 'APPROVED');
        // TODO: Filter only latest 2 Fiscal year data, based on current month and year
        // getCurrentFiscalYear by passing current month and year and 
        // filter data for currentFiscalyear and currentFiscalyear-1
        operData.forEach(entry => {
            const { communityPartners, associateStaffing, associatePresidentEmail, fiscalYear } = entry;

            const email = "email";
            const communityPartnersTxt = "communityPartners";

            if (fiscalYear) {
                if (!siteFiscalData[fiscalYear]) {
                    siteFiscalData[fiscalYear] = {};
                }
                if (!siteFiscalData[fiscalYear][email]) {
                    siteFiscalData[fiscalYear][email] = [];
                }
                siteFiscalData[fiscalYear][email].push({
                    associatePresidentEmail
                });
                if (!siteFiscalData[fiscalYear][communityPartnersTxt]) {
                    siteFiscalData[fiscalYear][communityPartnersTxt] = [];
                }
                siteFiscalData[fiscalYear][communityPartnersTxt].push(communityPartners);



                // fulltime, parttime and seasonal
                associateStaffing.employment.forEach(entry => {
                    const { employmentType, jobTitle, noOfStaffs } = entry;
                    if (!siteFiscalData[fiscalYear]['FullTime']) {
                        siteFiscalData[fiscalYear]['FullTime'] = [];
                    }
                    if (employmentType === 'Full-time')
                        siteFiscalData[fiscalYear]['FullTime'].push({
                            jobTitle,
                            noOfStaffs
                        });
                    if (!siteFiscalData[fiscalYear]['PartTime']) {
                        siteFiscalData[fiscalYear]['PartTime'] = [];
                    }
                    if (employmentType === 'Part-time')
                        siteFiscalData[fiscalYear]['PartTime'].push({
                            jobTitle,
                            noOfStaffs
                        });
                    if (!siteFiscalData[fiscalYear]['Seasonal']) {
                        siteFiscalData[fiscalYear]['Seasonal'] = [];
                    }
                    if (employmentType === 'Seasonal')
                        siteFiscalData[fiscalYear]['Seasonal'].push({
                            jobTitle,
                            noOfStaffs
                        });
                })

            }
        });
        return siteFiscalData;
    }

    const getAssociateFiscalData = (fiscalData) => {
        if (!fiscalData) return;
        const siteFiscalData = {};
        const currentFiscalYear = getFiscalYear(getCurrentYear, getCurrentMonth);
        console.log(`current Fiscal Year :${currentFiscalYear}`);
        // TODO: add this condition to the filter with current  && e.fiscalYear === currentFiscalYear
        const fisData = fiscalData.filter(e => e.status === 'APPROVED');
        // TODO: Filter only latest 2 Fiscal year data, based on current month and year
        // getCurrentFiscalYear by passing current month and year and 
        // filter data for currentFiscalyear and currentFiscalyear-1
        console.log(fisData);
        fisData.forEach(entry => {
            const { event, membership, assets, contributions, expenditures, fiscalYear } = entry;

            const membershipTxt = "membership";
            const revenue = "revenue";
            const assetsTxt = "assets";
            if (fiscalYear === "") {
                console.log('inside')
                if (!siteFiscalData[fiscalYear]) {
                    siteFiscalData[fiscalYear] = {};
                }
                if (!siteFiscalData[fiscalYear][membershipTxt]) {
                    siteFiscalData[fiscalYear][membershipTxt] = 0;
                }
                siteFiscalData[fiscalYear][membershipTxt] += parseInt(membership.noOfMembership) || 0;
                if (!siteFiscalData[fiscalYear][revenue]) {
                    siteFiscalData[fiscalYear][revenue] = {
                        surcharges: 0,
                        fundraisers: 0,
                        donationsContributions: 0,
                        sponsorships: 0,
                        honoraria: 0,
                        corpus: 0,
                        interestDividends: 0,
                        otherInterest: 0,
                        grantsPHMC: 0,
                        operationSite: 0,
                        otherPurpose: 0,
                        fundsJointProjects: 0,
                        legIntiativeGrants: 0,
                        miscellaneous: 0,
                        total: 0
                    };
                }

                siteFiscalData[fiscalYear][revenue] = {
                    surcharges: siteFiscalData[fiscalYear][revenue].surcharges + parseFloat(event.surcharges),
                    fundraisers: siteFiscalData[fiscalYear][revenue].fundraisers + parseFloat(event.fundraisers),
                    donationsContributions: siteFiscalData[fiscalYear][revenue].donationsContributions + parseFloat(event.donationsContributions),
                    sponsorships: siteFiscalData[fiscalYear][revenue].sponsorships + parseFloat(event.sponsorships),
                    honoraria: siteFiscalData[fiscalYear][revenue].honoraria + parseFloat(event.honoraria),
                    corpus: siteFiscalData[fiscalYear][revenue].corpus + parseFloat(event.corpus),
                    interestDividends: siteFiscalData[fiscalYear][revenue].interestDividends + parseFloat(event.interestDividends),
                    otherInterest: siteFiscalData[fiscalYear][revenue].otherInterest + parseFloat(event.otherInterest),
                    grantsPHMC: siteFiscalData[fiscalYear][revenue].grantsPHMC + parseFloat(event.grantsPHMC),
                    operationSite: siteFiscalData[fiscalYear][revenue].operationSite + parseFloat(event.operationSite),
                    otherPurpose: siteFiscalData[fiscalYear][revenue].otherPurpose + parseFloat(event.otherPurpose),
                    fundsJointProjects: siteFiscalData[fiscalYear][revenue].fundsJointProjects + parseFloat(event.fundsJointProjects),
                    legIntiativeGrants: siteFiscalData[fiscalYear][revenue].legIntiativeGrants + parseFloat(event.legIntiativeGrants),
                    miscellaneous: siteFiscalData[fiscalYear][revenue].miscellaneous + parseFloat(event.miscellaneous),
                    total: siteFiscalData[fiscalYear][revenue].total + parseFloat(event.total)
                };

                if (!siteFiscalData[fiscalYear][assetsTxt]) {
                    siteFiscalData[fiscalYear][assetsTxt] = {
                        fundsJointProjects: 0,
                        capitolAssets: 0,
                        cashBalanceOrReserve: 0,
                        total: 0
                    }
                }
                siteFiscalData[fiscalYear][assetsTxt] = {
                    fundsJointProjects: siteFiscalData[fiscalYear][assetsTxt].fundsJointProjects + parseFloat(assets.fundsJointProjects),
                    capitolAssets: siteFiscalData[fiscalYear][assetsTxt].capitolAssets + parseFloat(assets.capitolAssets),
                    cashBalanceOrReserve: siteFiscalData[fiscalYear][assetsTxt].cashBalanceOrReserve + parseFloat(assets.cashBalanceOrReserve),
                    total: siteFiscalData[fiscalYear][assetsTxt].total + parseFloat(assets.total) || 0
                }
                const contributionsTxt = "contributions";
                if (!siteFiscalData[fiscalYear][contributionsTxt]) {
                    siteFiscalData[fiscalYear][contributionsTxt] = {
                        cashValueOfProgram: 0,
                        contributedMaterials: 0,
                        contributedService: 0,
                        total: 0
                    }
                }
                siteFiscalData[fiscalYear][contributionsTxt] = {
                    cashValueOfProgram: contributions.cashValueOfProgram,
                    contributedMaterials: siteFiscalData[fiscalYear][contributionsTxt].contributedMaterials + parseFloat(contributions.contributedMaterials),
                    contributedService: siteFiscalData[fiscalYear][contributionsTxt].contributedService + parseFloat(contributions.contributedService),
                    total: siteFiscalData[fiscalYear][contributionsTxt].total + parseFloat(contributions.total) || 0
                }

                const expenditureTxt = "expenditures";
                if (!siteFiscalData[fiscalYear][expenditureTxt]) {
                    siteFiscalData[fiscalYear][expenditureTxt] = {
                        splEventAmount: 0,
                        membershipAmount: 0,
                        fundraising: 0,
                        grantsmanship: 0,
                        empSalaries: 0,
                        adminExpenses: 0,
                        siteImprovements: 0,
                        capitalExpenditures: 0,
                        collectionAcquisitions: 0,
                        utilities: 0,
                        waterSewegeSeptic: 0,
                        trashRemoval: 0,
                        groundsCare: 0,
                        pestControl: 0,
                        maintenanceSupplies: 0,
                        plumbingElectrical: 0,
                        houseKeeping: 0,
                        insurance: 0,
                        marketing: 0,
                        museumStore: 0,
                        consultantFees: 0,
                        depreciation: 0,
                        website: 0,
                        other: 0,
                        totalExpenditures: 0,
                        membership: 0
                    }
                }
                siteFiscalData[fiscalYear][expenditureTxt] = {
                    splEventAmount: siteFiscalData[fiscalYear][expenditureTxt].splEventAmount + parseFloat(expenditures.splEventAmount),
                    membershipAmount: siteFiscalData[fiscalYear][expenditureTxt].membershipAmount + parseFloat(expenditures.membershipAmount),
                    fundraising: siteFiscalData[fiscalYear][expenditureTxt].fundraising + parseFloat(expenditures.fundraising),
                    grantsmanship: siteFiscalData[fiscalYear][expenditureTxt].grantsmanship + parseFloat(expenditures.grantsmanship),
                    empSalaries: siteFiscalData[fiscalYear][expenditureTxt].empSalaries + parseFloat(expenditures.empSalaries),
                    adminExpenses: siteFiscalData[fiscalYear][expenditureTxt].adminExpenses + parseFloat(expenditures.adminExpenses),
                    siteImprovements: siteFiscalData[fiscalYear][expenditureTxt].siteImprovements + parseFloat(expenditures.siteImprovements),
                    capitalExpenditures: siteFiscalData[fiscalYear][expenditureTxt].capitalExpenditures + parseFloat(expenditures.capitalExpenditures),
                    collectionAcquisitions: siteFiscalData[fiscalYear][expenditureTxt].collectionAcquisitions + parseFloat(expenditures.collectionAcquisitions),
                    utilities: siteFiscalData[fiscalYear][expenditureTxt].utilities + parseFloat(expenditures.utilities),
                    waterSewegeSeptic: siteFiscalData[fiscalYear][expenditureTxt].waterSewegeSeptic + parseFloat(expenditures.waterSewegeSeptic),
                    trashRemoval: siteFiscalData[fiscalYear][expenditureTxt].trashRemoval + parseFloat(expenditures.trashRemoval),
                    groundsCare: siteFiscalData[fiscalYear][expenditureTxt].groundsCare + parseFloat(expenditures.groundsCare),
                    pestControl: siteFiscalData[fiscalYear][expenditureTxt].pestControl + parseFloat(expenditures.pestControl),
                    maintenanceSupplies: siteFiscalData[fiscalYear][expenditureTxt].maintenanceSupplies + parseFloat(expenditures.maintenanceSupplies),
                    plumbingElectrical: siteFiscalData[fiscalYear][expenditureTxt].plumbingElectrical + parseFloat(expenditures.plumbingElectrical),
                    houseKeeping: siteFiscalData[fiscalYear][expenditureTxt].houseKeeping + parseFloat(expenditures.houseKeeping),
                    insurance: siteFiscalData[fiscalYear][expenditureTxt].insurance + parseFloat(expenditures.insurance),
                    marketing: siteFiscalData[fiscalYear][expenditureTxt].marketing + parseFloat(expenditures.marketing),
                    museumStore: siteFiscalData[fiscalYear][expenditureTxt].museumStore + parseFloat(expenditures.museumStore),
                    consultantFees: siteFiscalData[fiscalYear][expenditureTxt].consultantFees + parseFloat(expenditures.consultantFees),
                    depreciation: siteFiscalData[fiscalYear][expenditureTxt].depreciation + parseFloat(expenditures.depreciation),
                    website: siteFiscalData[fiscalYear][expenditureTxt].website + parseFloat(expenditures.website),
                    other: siteFiscalData[fiscalYear][expenditureTxt].other + parseFloat(expenditures.other),
                    totalExpenditures: siteFiscalData[fiscalYear][expenditureTxt].totalExpenditures + parseFloat(expenditures.totalExpenditures) || 0,
                    membership: siteFiscalData[fiscalYear][expenditureTxt].membership + parseFloat(expenditures.membership)
                }

            }
        });
        return siteFiscalData;
    }

    // console.log(`operationalData:${Object.entries(operationalData)}, length:${(operationalData ? Object.keys(operationalData).length : 'undefined')}`);

    const getCommunityPartners = (operationalData) => {
        if (!operationalData) return;
        const resultArray = [['Businesses', 'Educational Institutions', 'Other State Agencies', 'Others']]
        Object.entries(operationalData).forEach((fiscalYear, data) => {
            // console.log(`communityPartners Record:${Object.entries(fiscalYear[1].communityPartners)},data:${data}`);
            fiscalYear[1].communityPartners.map(data => resultArray.push([data.businesses, data.eduInstitutions, data.otherStateAgencies, data.others]));
        })
        return resultArray;
    }
    const communityPartners = getCommunityPartners(operationalData);
    console.log("communityPartners:" + communityPartners);

    const getAssociateStaffing = (operationalData) => {
        if (!operationalData) return;
        const resultArray = [['Associate Staffing', 'Number of Staff', 'Job Titles']]
        Object.entries(operationalData).forEach((fiscalYear, data) => {
            if (fiscalYear[1].FullTime)
                fiscalYear[1].FullTime.forEach(data => resultArray.push(['Full Time', data.noOfStaffs, data.jobTitle]));
            if (fiscalYear[1].PartTime)
                fiscalYear[1].PartTime.forEach(data => resultArray.push(['Part Time', data.noOfStaffs, data.jobTitle]));
            fiscalYear[1].Seasonal.forEach(data => resultArray.push(['Seasonal', data.noOfStaffs, data.jobTitle]));

        })
        return resultArray;
    }
    const associateStaffing = getAssociateStaffing(operationalData);
    console.log("associateStaffing:" + associateStaffing);

    const getPresidentEmail = (operationalData) => {
        if (!operationalData) return;
        const resultArray = [['Name', 'Email Contact']]
        Object.entries(operationalData).forEach((fiscalYear) => {
            fiscalYear[1].email.forEach(data => resultArray.push([data.associatePresidentName, data.associatePresidentEmail]))

        })
        return resultArray;
    }
    const emailInfo = getPresidentEmail(operationalData);
    console.log("email:" + emailInfo);

    const getFiscalMembership = (fiscalData) => {
        if (!fiscalData) return;
        const resultArray = [['No of Membership']]
        Object.entries(fiscalData).forEach((fiscalYear) => {
            resultArray.push([fiscalYear[1].membership])
        })

        return resultArray;
    }
    const membershipInfo = getFiscalMembership(fiscalData);

    console.log("membershipInfo:" + membershipInfo);
    const getFiscalRevenue = (fiscalData) => {
        if (!fiscalData) return;
        const resultArray = [['Surcharges', 'Fundraisers', 'Donations', 'Sponsorship', 'honoraria', 'Corpus', 'Interest Dividends', 'Other Interest'
            , 'Grants PHMC', 'Operation Site', 'Other Purpose', 'Funds Joint Projects', 'legislative Initiative Grants', 'Miscellaneous', 'Total']]
        Object.entries(fiscalData).forEach((fiscalYear) => {
            resultArray.push([fiscalYear[1].revenue.surcharges, fiscalYear[1].revenue.fundraisers, fiscalYear[1].revenue.donationsContributions, fiscalYear[1].revenue.sponsorships,
            fiscalYear[1].revenue.honoraria, fiscalYear[1].revenue.corpus, fiscalYear[1].revenue.interestDividends, fiscalYear[1].revenue.otherInterest,
            fiscalYear[1].revenue.grantsPHMC, fiscalYear[1].revenue.operationSite, fiscalYear[1].revenue.otherPurpose, fiscalYear[1].revenue.fundsJointProjects,
            fiscalYear[1].revenue.legIntiativeGrants, fiscalYear[1].revenue.miscellaneous, fiscalYear[1].revenue.total])
        })

        return resultArray;
    }
    const fiscalRevenue = getFiscalRevenue(fiscalData);
    console.log("fiscalRevenue:" + fiscalRevenue);

    const getFiscalAssets = (fiscalData) => {
        if (!fiscalData) return;
        const resultArray = [['Funds Joint Projects',
            'Capitol Assets',
            'Cash Balance Or Reserve', 'Total']]
        Object.entries(fiscalData).forEach((fiscalYear) => {
            console.log(fiscalYear[1]);
            resultArray.push([fiscalYear[1].assets.fundsJointProjects, fiscalYear[1].assets.capitolAssets, fiscalYear[1].assets.cashBalanceOrReserve, fiscalYear[1].assets.total])
        })

        return resultArray;
    }
    const fiscalAssets = getFiscalAssets(fiscalData);
    console.log("fiscalAssets:" + fiscalAssets);

    const getFiscalContributions = (fiscalData) => {
        if (!fiscalData) return;
        const resultArray = [['Cash Value Of Program',
            'Contributed Materials',
            'Contributed Service', 'Total']]
        Object.entries(fiscalData).forEach((fiscalYear) => {
            console.log(fiscalYear[1]);
            resultArray.push([fiscalYear[1].contributions.cashValueOfProgram,
            fiscalYear[1].contributions.contributedMaterials,
            fiscalYear[1].contributions.contributedService,
            fiscalYear[1].contributions.total])
        })
        return resultArray;
    }
    const fiscalContributions = getFiscalContributions(fiscalData);
    console.log("fiscalContributions:" + fiscalContributions);

    const getFiscalExpenditures = (fiscalData) => {
        if (!fiscalData) return;
        const resultArray = [['splEventAmount',
            'membershipAmount',
            'fundraising', 'grantsmanship', 'empSalaries'
            , 'adminExpenses', 'siteImprovements', 'capitalExpenditures'
            , 'collectionAcquisitions'
            , 'utilities'
            , 'waterSewegeSeptic'
            , 'trashRemoval'
            , 'groundsCare'
            , 'pestControl'
            , 'maintenanceSupplies'
            , 'plumbingElectrical'
            , 'houseKeeping'
            , 'insurance', 'marketing', 'museumStore', 'consultantFees',
            'depreciation', 'website', 'other', 'totalExpenditures', 'membership']]

        Object.entries(fiscalData).forEach((fiscalYear) => {
            console.log(fiscalYear[1]);
            resultArray.push([fiscalYear[1].expenditures.splEventAmount,
            fiscalYear[1].expenditures.membershipAmount,
            fiscalYear[1].expenditures.fundraising,
            fiscalYear[1].expenditures.grantsmanship,
            fiscalYear[1].expenditures.empSalaries,
            fiscalYear[1].expenditures.adminExpenses,
            fiscalYear[1].expenditures.siteImprovements,
            fiscalYear[1].expenditures.capitalExpenditures,
            fiscalYear[1].expenditures.collectionAcquisitions,
            fiscalYear[1].expenditures.utilities,
            fiscalYear[1].expenditures.waterSewegeSeptic,
            fiscalYear[1].expenditures.trashRemoval,
            fiscalYear[1].expenditures.groundsCare,
            fiscalYear[1].expenditures.pestControl,
            fiscalYear[1].expenditures.maintenanceSupplies,
            fiscalYear[1].expenditures.plumbingElectrical,
            fiscalYear[1].expenditures.houseKeeping,
            fiscalYear[1].expenditures.insurance,
            fiscalYear[1].expenditures.marketing,
            fiscalYear[1].expenditures.museumStore,
            fiscalYear[1].expenditures.consultantFees,
            fiscalYear[1].expenditures.depreciation,
            fiscalYear[1].expenditures.website,
            fiscalYear[1].expenditures.other,
            fiscalYear[1].expenditures.totalExpenditures,
            fiscalYear[1].expenditures.membership])
        })
        return resultArray;
    }
    const fiscalExpenditures = getFiscalExpenditures(fiscalData);
    console.log("fiscalExpenditures:" + fiscalExpenditures);

    const downloadCSV = () => {

        const combinedData = [
            ['Revenue'],
            ...fiscalRevenue.map(row => row.join(',')),
            [''],
            ['Assets'],
            ...fiscalAssets.map(row => row.join(',')),
            [''],
            ['Contributions'],
            ...fiscalContributions.map(row => row.join(',')),
            [''],
            ['Expenditures'],
            ...fiscalExpenditures.map(row => row.join(',')),
            [''],
            ['Membership'],
            ...membershipInfo.map(row => row.join(',')),
            [''],
            ['Major Community Partners'],
            ...communityPartners.map(row => row.join(',')),
            [''],
            ['Associate Staffing'],
            ...associateStaffing.map(row => row.join(',')),
            [''],
            ['Name of Associate President'],
            ...emailInfo.map(row => row.join(',')),
            [''],
        ];

        // Convert the chart data to CSV format
        const csvContent = combinedData.join('\n');
        // Create a data URI for the CSV content
        const encodedUri = encodeURI('data:text/csv;charset=utf-8,' + csvContent);
        // Create a download link
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'SiteAssociateAnnualReport.csv');
        // Append the link to the document body and trigger the click event
        document.body.appendChild(link);
        link.click();
    };
    const createDownloadHandler = () => {
        return () => downloadCSV();
    };

    return (
        <>
            <span ><b>Site Associate Annual Report </b> </span>
            {operationalData.length > 0 &&
                <Row className="mb-0 main-content" >
                    <Col>
                        <Button onClick={createDownloadHandler()}>Download Data</Button>
                    </Col>
                    <Col />
                    <Col />
                    <Col />
                </Row>
            }
            <Row className="mb-0 main-content" >
                <Col>
                    <Card>
                        <Card.Body>
                            <Form>
                                <Row className="mb-0 main-content" >
                                    <Form.Group as={Col} >
                                        <Form.Label>Select Site Name </Form.Label>
                                        <Form.Select defaultValue="" name="siteName" required onChange={handleSiteChange}>
                                            <option value="">Select</option>
                                            <option>ANTHRACITE HERITAGE</option>
                                            <option>BRANDYWINE BATTLEFIELD</option>
                                            <option>BUSHY </option>
                                            <option>CONRAD W</option>
                                            <option>CORNWALL</option>
                                            <option>DANIEL B</option>
                                            <option>DRAKE WELL</option>
                                            <option>ECKLEY MINERS' VLGE</option>
                                            <option>EPHRATA CLOISTER</option>
                                            <option>ERIE MARITIME</option>
                                            <option>FORT PITT</option>
                                            <option>GRAEME </option>
                                            <option>HOPE</option>
                                            <option>JOSEPH P</option>
                                            <option>LANDIS VALLEY</option>
                                            <option>OLD ECONOMY</option>
                                            <option>PENNSBURY</option>
                                            <option>PA LUMBER MUSEUM</option>
                                            <option>PA MILITARY MUSEUM</option>
                                            <option>RAILROAD MUSEUM</option>
                                            <option>SOMERSET</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formYear">

                                    </Form.Group>
                                    <Col />
                                </Row>
                            </Form>

                        </Card.Body>


                    </Card>
                </Col>

            </Row>
            <>
                <Row className="mb-0 main-content" >
                    <Card>
                        <Card.Title>Revenue </Card.Title>
                        {spinner && (<Spinner />)}
                        <Card.Body>
                            <Row className="mb-0 main-content" >
                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={fiscalRevenue} />
                            </Row>
                        </Card.Body>
                    </Card>
                </Row>
                <Row className="mb-0 main-content" >
                    <Card>
                        <Card.Title>Assets </Card.Title>
                        {spinner && (<Spinner />)}
                        <Card.Body>
                            <Row className="mb-0 main-content" >
                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={fiscalAssets}

                                />
                            </Row>
                        </Card.Body>
                    </Card>
                </Row>
                <Row className="mb-0 main-content" >
                    <Card>
                        <Card.Title>Contributions </Card.Title>
                        {spinner && (<Spinner />)}
                        <Card.Body>
                            <Row className="mb-0 main-content" >
                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={fiscalContributions}

                                />
                            </Row>
                        </Card.Body>
                    </Card>
                </Row>
                <Row className="mb-0 main-content" >
                    <Card>
                        <Card.Title>Expenditures</Card.Title>
                        {spinner && (<Spinner />)}
                        <Card.Body>
                            <Row className="mb-0 main-content" >
                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={fiscalExpenditures}

                                />
                            </Row>
                        </Card.Body>
                    </Card>
                </Row>
                <Row className="mb-0 main-content" >
                    <Card>
                        <Card.Title>Membership </Card.Title>
                        {spinner && (<Spinner />)}
                        <Card.Body>
                            <Row className="mb-0 main-content" >
                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={membershipInfo}

                                />
                            </Row>


                        </Card.Body>
                    </Card>
                </Row>
            </>
            {spinner && (<Spinner />)}
            {(operationalData && Object.keys(operationalData).length > 0) ? <>
                {/* <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Number of members </Card.Title>
                            <Card.Body>

                                {/* <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={emailInfo}

                                /> 
                            </Card.Body>
                        </Card>
                    </Col>
                </Row> */}
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Major Community Partners  </Card.Title>
                            <Card.Body>

                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={communityPartners}

                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title> Associate Staffing  </Card.Title>
                            <Card.Body>

                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={associateStaffing}

                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-0 main-content" >
                    <Col>
                        <Card>
                            <Card.Title>Name of Associate President  </Card.Title>
                            <Card.Body>

                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={emailInfo}

                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </> : <Row className="mb-0 main-content" >No data found!</Row>}
        </>
    );
}